var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIWatch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99877 11.1614C9.85504 11.1614 11.3598 9.65656 11.3598 7.80028C11.3598 5.94401 9.85504 4.43921 7.99877 4.43921C6.1425 4.43921 4.6377 5.94401 4.6377 7.80028C4.6377 9.65656 6.1425 11.1614 7.99877 11.1614Z",
    stroke: "#82868C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99961 10.2001C9.32509 10.2001 10.3996 9.12563 10.3996 7.80015C10.3996 6.47466 9.32509 5.40015 7.99961 5.40015C6.67413 5.40015 5.59961 6.47466 5.59961 7.80015C5.59961 9.12563 6.67413 10.2001 7.99961 10.2001Z",
    fill: "#82868C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99886 11.1613C7.4342 11.1613 6.90027 11.0192 6.43164 10.7734V12.9437C6.43164 13.3662 6.77735 13.7119 7.19989 13.7119H8.794C9.21653 13.7119 9.56224 13.3662 9.56224 12.9437V10.7734C9.09361 11.0192 8.56352 11.1613 7.99502 11.1613H7.99886Z",
    fill: "#82868C",
    stroke: "#82868C",
    strokeWidth: 0.576184,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99893 4.43917C8.56359 4.43917 9.09752 4.5813 9.56615 4.82714V3.05633C9.56615 2.6338 9.22044 2.28809 8.7979 2.28809H7.20379C6.78126 2.28809 6.43555 2.6338 6.43555 3.05633V4.82714C6.90418 4.5813 7.43427 4.43917 8.00277 4.43917H7.99893Z",
    fill: "#82868C",
    stroke: "#82868C",
    strokeWidth: 0.576184,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIWatch);
export default __webpack_public_path__ + "static/media/i_watch.3e292c0685997005bd61ca6983e9e4c0.svg";
export { ForwardRef as ReactComponent };